export default () => ({
  open:false,
  value: '',
  textValue: '',
  isValid: true,
  disabled: false,
  options: [],
  placeholder: '',
  direction: 'bottom', // default orientation
  typeahead: '', // arrow + kb navigation
  init(){
    const selectElement = this.$el.querySelector('select')
    this.value = selectElement.value
    this.$watch('value', (newValue) => selectElement.value = newValue)

    this.options = Array.from(selectElement.options).map((el) => { return {value: el.value, text: el.innerText, disabled: el.disabled} })
    this.placeholder = selectElement.getAttribute('placeholder')
    this.textValue = selectElement.querySelector('option:checked')?.innerText
    this.isValid = selectElement.checkValidity()
    this.disabled = selectElement.disabled

    // https://github.com/radix-ui/primitives/blob/main/packages/react/select/src/select.tsx#L1654
    let timeout
    this.$watch('typeahead', value => {
      window.clearTimeout(timeout)
      if(value != '') timeout = setTimeout(() => this.typeahead = '', 1000)
    })
  },
  toggleOpen(){
    if(this.open) return this.open = false
    // calc direction and open
    const yPos = this.$refs.select.getBoundingClientRect().y
    const selectHeight = this.$refs.select.getBoundingClientRect().height
    this.direction = yPos + selectHeight > window.innerHeight ? 'top' : 'bottom'
    this.open = true
    // focus selected option if any
    const selected = this.$el.querySelector('[data-state=checked]')
    if(selected) this.$nextTick(() => selected.focus({ preventScroll: true }))
  },
  onHover(e){
    e.target.focus({ preventScroll: true })
  },
  onSelect(el){
    this.value = el.dataset.value
    this.textValue = el.innerText
    this.open = false

    this.$nextTick(() => {
      const selectElement = this.$root.querySelector('select')
      // 1. update validity
      this.isValid = selectElement.checkValidity()
      // 2. trigger change for listeners
      selectElement.dispatchEvent(new Event('change'))
    })
  },
  onKeyDown(e){
   if(e.key != 'Tab') e.preventDefault()
    // https://github.com/radix-ui/primitives/blob/main/packages/react/select/src/select.tsx#L300
    const isTypingAhead = this.typeahead != ''
    const isModifierKey = e.ctrlKey || e.altKey || e.metaKey
    const isOpenKey = e.key == 'ArrowUp' || e.key == 'ArrowDown'
    if (isOpenKey && !this.open) this.toggleOpen()
    if (!isModifierKey && e.key.length === 1) this.updateSearch(e.key)
    if (isTypingAhead && e.key === ' ') return
    if (e.key == 'Enter') this.onSelect(document.activeElement)
    if (e.key == 'ArrowUp') this.focusItem('prev')
    if (e.key == 'ArrowDown') this.focusItem('next')
  },
  focusItem(which){
    const currentItem = this.options.find((item) => item.value == document.activeElement.dataset.value)
    if(!currentItem) return
    const currentItemIndex = this.options.indexOf(currentItem)
    const currentItemElement = this.$el.querySelectorAll(`[role='option']`)[currentItemIndex];
    if(which == 'next' && currentItemIndex+1 <= this.options.length-1){
      let nextItem = currentItemElement.nextElementSibling
      while(nextItem && nextItem.nodeName === 'DIV' && nextItem.dataset.disabled){ nextItem = nextItem.nextElementSibling }
      nextItem?.focus()
    }else if(which == 'prev' && currentItemIndex-1 >= 0){
      let nextItem = currentItemElement.previousElementSibling
      while(nextItem && nextItem.nodeName === 'DIV' && nextItem.dataset.disabled){ nextItem = nextItem.previousElementSibling }
      nextItem?.focus()
    }
  },
  updateSearch(key){
    this.typeahead = this.typeahead + key
    this.focusNextMatchingItem(this.typeahead)
  },
  focusNextMatchingItem(search){
    let optionArray = this.options
    // https://github.com/radix-ui/primitives/blob/main/packages/react/select/src/select.tsx#L1693
    const currentItem = this.options.find((item) => item.value == document.activeElement.dataset.value)
    const currentItemIndex = currentItem ? this.options.indexOf(currentItem) : -1
    let wrappedItems = this.options.map((e, index) => optionArray[(Math.max(currentItemIndex, 0) + index) % optionArray.length])
    const nextItem = wrappedItems.find((item) =>
      !item.disabled && item.text.toLowerCase().startsWith(search.toLowerCase())
    )
    if(nextItem) this.$el.querySelector(`[data-value='${nextItem.value}']`)?.focus()
  }
})